module.exports = __webpack_public_path__ + "src/assets/img/cmd-go-ahj.6d6fa4b1.svg";